<template>
  <div class="px-2" >
    <h2>{{ title }}</h2>
    <div class="flex flex-wrap -mx-2">
      <div  v-for="address in addresses" class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4">
        <div :class="['card simple-card', loading && currentAddress === address.uid ? 'opacity-50' : '', selected.uid === address.uid ? 'selected' : '']">
          <div v-if="selected.uid === address.uid" class="chosen">
            <span class="md:hidden sm:hidden" >Ausgewählt</span>
            <icon name="check"></icon>
          </div>
          <div @click.prevent="select(address)" class="address">
            <h6>{{ address.first_name + ' ' + address.last_name }}</h6>
            <span>{{ address.company }}</span>
            <span>{{ address.street + address.number }}</span>
            <span>{{ address.city }}, {{ address.region }} {{ address.zip }}</span>
            <span>{{ address.country }}</span>
            <span>{{ address.tel }}</span>
          </div>
          <div class="actions">
            <a class="edit" @click.prevent="changeAddress(address)">Bearbeiten</a>
            <span v-if="address.default" class="text-cg-success">Standard</span>
            <a v-if="!address.default" class="standard" @click.prevent="setToDefault(address)">Als Standard festlegen</a>
            <a v-if="selected.uid !== address.uid" class="delete" @click.prevent="removeAddress(address.uid)">Löschen</a>
          </div>
        </div>
      </div>
      <div class="w-1/3 md:w-1/2 sm:w-full px-2 mb-4">
        <div class="card simple-card new-card">
          <button @click.prevent="toggleAddressModal" class="btn icon green">
            <span><icon class="icon" name="plus-circle"></icon></span>
            <span>Neue Addresse hinzufügen</span>
          </button>
        </div>
      </div>
    </div>

    <address-modal v-on:saved="select" :modal-name="modalName" ></address-modal>
  </div>
</template>

<script>
  import { EventBus } from '@/assets/js/event-bus.js'
  import {mapGetters, mapActions} from 'vuex'
  import AddressModal from '../modals/Address'

  export default {
    components: {AddressModal},
    name: 'userAddress',
    props: {
      modalName: {
        type: String,
        default: 'address'
      },
      selected: {
        type: Object,
        default: function () {
          return {}
        }
      },
      forcePreselect: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Meine Adressen'
      }
    },
    data () {
      return {
        userInfo: {},
        currentAddress: '',
        saveToast: null,
        noAddressYet: false
      }
    },
    mounted () {
      var self = this
      this.getAddresses(
        {
          userUid: this.account.uid,
          cb () {
            if (self.modalName === 'delivery' || self.forcePreselect) {
              self.searchPreselect()
            }
          }
        })
      if (self.forcePreselect) {
        if (self.addresses.length) {
          self.searchPreselect()
        } else {
          self.noAddressYet = true
        }
      }
    },
    methods: {
      ...mapActions([
        'getAddresses',
        'deleteAddress',
        'updateAddress'
      ]),
      searchPreselect () {
        var self = this
        if (!self.selected.uid) {
          for (var p in self.addresses) {
            console.log(self.modalName, self.addresses[p])
            if (self.addresses[p].default) {
              self.preselect(self.addresses[p])
            }
          }
        }
      },
      toggleAddressModal () {
        EventBus.$emit('toggleAddressModal', null, this.modalName)
      },
      changeAddress (address) {
        this.currentAddress = address.uid
        EventBus.$emit('toggleAddressModal', address, this.modalName)
      },
      removeAddress (address) {
        var vm = this
        vm.currentAddress = address
        var cb = () => {
          vm.$toasted.success('Die ausgewählte Addresse wurde gelöscht.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'check'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        var errorCb = () => {
          vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        vm.$dialog.confirm('Möchtest Du diese Addresse löschen?').then(() => {
          if (!vm.saveToast) {
            vm.saveToast = vm.$toasted.info('Wird gelöscht...', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              icon: 'info'
            })
            vm.deleteAddress({user: vm.account.uid, address: address, cb, errorCb})
          }
        }).catch(() => {})
      },
      setToDefault (address) {
        var vm = this
        var data = {default: true}
        var cb = () => {
          vm.$toasted.success('Die ausgewählte Addresse wurde als Standard gesetzt.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'check'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        var errorCb = () => {
          vm.$toasted.error('Leider ist ein Fehler aufgetreten.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'close'
          })
          vm.saveToast.goAway(100)
          vm.saveToast = null
        }
        if (!vm.saveToast) {
          vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            icon: 'info'
          })
          vm.updateAddress({user: vm.account.uid, address: address.uid, data, cb, errorCb})
        }
      },
      preselect (address) {
        this.$emit('preselected', address)
      },
      select (address) {
        this.$emit('selected', address)
      }
    },
    computed: {
      ...mapGetters({
        'addresses': 'user_get_addresses',
        'account': 'auth_get_account',
        loading: 'options_is_loading'
      })
    },
    watch: {
      addresses: function (value) {
        if (this.noAddressYet && this.forcePreselect) {
          this.searchPreselect()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/userAddress.vue